function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { checkboxAnatomy as parts } from "@chakra-ui/anatomy";
export { CheckboxGroup, useCheckbox, useCheckboxGroup } from "@chakra-ui/react";
import { Checkbox as ChakraCheckbox, forwardRef } from "@chakra-ui/react";
import { CheckboxIcon } from "./CheckboxIcon";
const baseStyleControl = {
    w: '100%',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    bg: 'transparent',
    border: '1px solid',
    borderRadius: 'base',
    borderColor: 'border.neutral.primary.default',
    color: 'text.neutral.primary.default',
    transform: 'perspective(1000px) translateZ(0px)',
    _active: {
        transform: 'perspective(1000px) translateZ(-50px)'
    },
    _checked: {
        bg: 'background.accent.primary.default',
        borderColor: 'border.accent.primary.default',
        color: 'white',
        _hover: {
            bg: 'background.accent.primary.hovered',
            borderColor: 'border.accent.primary.hovered'
        },
        _disabled: {
            borderColor: 'border.neutral.primary.disabled',
            bg: 'background.neutral.primary.disabled',
            color: 'text.neutral.primary.disabled'
        }
    },
    _indeterminate: {
        bg: 'background.accent.primary.default',
        borderColor: 'border.accent.primary.default',
        color: 'white'
    },
    _disabled: {
        bg: 'background.neutral.primary.disabled',
        borderColor: 'background.neutral.primary.disabled',
        _dark: {
            bg: 'border.neutral.primary.disabled',
            borderColor: 'border.neutral.primary.disabled'
        }
    },
    _focus: {
        outline: 'border.accent.primary.default solid 1px',
        outlineOffset: '2px',
        boxShadow: 'none'
    },
    _invalid: {
        borderColor: 'border.feedback.error.default',
        _dark: {
            borderColor: 'border.feedback.error.default'
        }
    }
};
const baseStyleLabel = {
    userSelect: 'none',
    _disabled: {
        opacity: 1,
        color: 'text.neutral.primary.disabled'
    }
};
const baseStyleIcon = {
    transitionProperty: 'transform',
    transitionDuration: 'normal'
};
const baseStyle = {
    icon: baseStyleIcon,
    control: baseStyleControl,
    label: baseStyleLabel
};
const sizes = {
    sm: {
        control: {
            h: '16px',
            w: '16px'
        },
        label: {
            fontSize: 'sm'
        },
        icon: {
            fontSize: '0.55rem'
        }
    },
    md: {
        control: {
            w: '20px',
            h: '20px'
        },
        label: {
            fontSize: 'md'
        },
        icon: {
            fontSize: '0.625rem'
        }
    },
    lg: {
        control: {
            w: '24px',
            h: '24px'
        },
        label: {
            fontSize: 'lg'
        },
        icon: {
            fontSize: '0.8rem'
        }
    }
};
const defaultProps = {
    size: 'md',
    icon: /*#__PURE__*/ _jsx(CheckboxIcon, {})
};
export const ThemedCheckbox = {
    parts: parts.keys,
    baseStyle,
    sizes,
    defaultProps
};
const Checkbox = forwardRef((props, ref)=>{
    const customProps = {};
    // Testing a custom checkbox is hard, so lets make it easier :)
    if (typeof props.isChecked !== 'undefined') {
        customProps['aria-checked'] = props.isChecked ? 'true' : 'false';
    }
    return /*#__PURE__*/ _jsx(ChakraCheckbox, _object_spread({
        ref: ref
    }, customProps, props));
});
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = 'Checkbox';
export { Checkbox };

//# sourceMappingURL=Checkbox.js.map